var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "device-list" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-hashtag" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("device.titles.listRegistration")))]),
      ]),
      _vm._v(" "),
      _c(
        "UiDrawer",
        {
          attrs: {
            title: _vm.$t("device.registrations.send_licences.title_drawer"),
          },
          model: {
            value: _vm.isDrawerOpen,
            callback: function ($$v) {
              _vm.isDrawerOpen = $$v
            },
            expression: "isDrawerOpen",
          },
        },
        [
          _c("span", {
            staticClass: "my-3",
            domProps: {
              innerHTML: _vm._s(
                _vm.$tc(
                  "device.registrations.send_licences.info",
                  _vm.sendableCount,
                  { count: _vm.sendableCount }
                )
              ),
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "column is-8 is-offset-2 mt-4" },
            [
              _c("ExcelManagement", {
                attrs: {
                  "licences-ids": _vm.selectedItems.map(function (item) {
                    return item.id
                  }),
                },
                on: { reload: _vm.getRegistrations },
              }),
              _vm._v(" "),
              _vm.errorSQS
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-danger",
                      attrs: { role: "alert" },
                    },
                    [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("users.errorMessages.titleTechnicalIssue")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("users.errorMessages.technicalIssue")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("UiCard", [
        _c(
          "div",
          { staticClass: "d-flex align-items-center gap-3 mb-4" },
          [
            _c("h6", { staticClass: "m-0" }, [
              _vm._v(_vm._s(_vm.$t("device.registrations.mass_actions"))),
            ]),
            _vm._v(" "),
            _c(
              "Button2",
              {
                attrs: { disabled: !_vm.sendableCount },
                nativeOn: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleDrawer($event)
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("device.registrations.send_licences.title")) +
                    "\n        "
                ),
                _c("span", { staticClass: "text-mono" }, [
                  _vm._v("(" + _vm._s(_vm.sendableCount) + ")"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "Button2",
              {
                attrs: { disabled: !_vm.cancelableCount },
                nativeOn: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleCancelLicences($event)
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("device.registrations.cancel_licences.title")
                    ) +
                    "\n        "
                ),
                _c("span", { staticClass: "text-mono" }, [
                  _vm._v("(" + _vm._s(_vm.cancelableCount) + ")"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "Button2",
              {
                attrs: { disabled: !_vm.resendableCount },
                nativeOn: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleResendLicences($event)
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("device.registrations.resend_licences.title")
                    ) +
                    "\n        "
                ),
                _c("span", { staticClass: "text-mono" }, [
                  _vm._v("(" + _vm._s(_vm.resendableCount) + ")"),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mb-4" }, [
          !_vm.loading
            ? _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$tc("device.registrations.table_count", _vm.count, {
                      count: _vm.count,
                    })
                  )
                ),
              ])
            : _c("span", [_vm._v(" ")]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "position-relative" },
          [
            _vm.inProgress
              ? _c("div", { staticClass: "progress progress-table" }, [
                  _c("div", {
                    staticClass:
                      "progress-bar progress-bar-striped progress-bar-animated",
                    style: { width: _vm.progressBar + "%" },
                    attrs: {
                      role: "progressbar",
                      "aria-label": _vm.$t("device.registrations.progression"),
                      "aria-valuenow": _vm.progressBar,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100",
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("SuperTable", {
              ref: "tableIdentifications",
              attrs: {
                tableColumns: _vm.tableColumns,
                tableData: _vm.tableData,
                loading: _vm.loading,
              },
              on: {
                expired: _vm.handleExpired,
                reload: _vm.loadData,
                qrcode: _vm.handleAssociation,
                cancel: _vm.handleCancel,
                send: _vm.handleSend,
                sendfirsttime: _vm.handleSendFirstTime,
                sort: _vm.handleSort,
                filter: _vm.handleFilter,
                onSelectAll: _vm.handleSelectAll,
                onSelectRow: _vm.handleSelectItem,
                associate: _vm.handleAssociation,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("Toolbar", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-browseAssoc-licences",
                  expression: "'beepiz-browseAssoc-licences'",
                },
              ],
              staticClass: "col",
            },
            [
              _c(
                "div",
                {
                  staticClass: "toolbar-control d-flex align-items-center",
                  on: { click: _vm.handleCheckDevices },
                },
                [
                  _c("span", [
                    _c(
                      "span",
                      {
                        staticClass: "checkbox rounded",
                        class: { check: _vm.checkDevices },
                        staticStyle: {
                          "border-radius": "3px",
                          "margin-right": "15px",
                        },
                      },
                      [_c("i", { staticClass: "fa fa-check" })]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "line-height": "1",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("device.registrations.associated")))]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col center" },
            [
              _c("Pagination", {
                ref: "pagination",
                on: { change: _vm.handlePagination },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              { staticClass: "float-right" },
              [
                _c(
                  "Btn",
                  {
                    directives: [
                      {
                        name: "can",
                        rawName: "v-can",
                        value: "beepiz-browseAssoc-licences",
                        expression: "'beepiz-browseAssoc-licences'",
                      },
                    ],
                    class: [
                      {
                        "no-hover": _vm.showActionsDL,
                        disabled: _vm.lockDLBtn,
                      },
                      "default",
                    ],
                    staticStyle: { "margin-left": "auto" },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.licencesExport("xls")
                      },
                    },
                  },
                  [
                    _c("span", [
                      _c("i", { staticClass: "fa fa-download" }),
                      _vm._v("   " + _vm._s(_vm.$t("global.download"))),
                    ]),
                    _vm._v(" "),
                    _c("LoadingMini", { ref: "loading" }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }